export const AIDE_PRODUCT_MODES = [
  'contextful',
  'admin',
  'forge',
  'vhoop',
  'microsoft365',
  'mobile',
  'browser',
  'edge',
  'community',
] as const

export type AideProductMode = typeof AIDE_PRODUCT_MODES[number]

export function applyAideProductMode(mode: AideProductMode, root: HTMLElement = document.documentElement) {
  root.dataset.aideProduct = mode
}
